<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="animated fadeIn vld-parent pb-1" style="height: 100%; background-color: #fcfcfc">
    <b-row>
      <b-col>
        <div style=" padding: 5px 32px 4px;border-bottom: 1px solid gray; ">
          <b-row>
            <b-col md="3" style="padding: 7px" class="my-auto">
              <span style="font-weight: bolder">Termine für BaumNr.: {{tree_number}} </span>
            </b-col>
            <b-col>
              <b-button variant="primary" v-if="canGoBack" v-on:click="goBack" class="px-4 float-right ml-3">Zurück</b-button>

              <b-button-group style="float: right">
                <b-button variant="primary" class="px-4" style="border-right: 1px solid lightgray;" v-on:click="gotoTree">Baum
                </b-button>
                <b-button variant="primary" class="px-4" style="border-left: 1px solid lightgray; border-right: 1px solid lightgray" v-on:click="gotoControls">Kontrollen
                </b-button>
                <b-button variant="primary" class="px-4" style="border-left: 1px solid lightgray;" v-on:click="gotoTasks">Maßnahmen</b-button>
                <b-button variant="dark" class="px-4" disabled style="border-left: 1px solid lightgray;" v-on:click="">Termine
                </b-button>
              </b-button-group>

              <b-button variant="success" v-on:click="showAppointmentModal" class="px-4 float-right mr-3">Termin anlegen</b-button>


            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
    <b-row style="padding-left: 15px; padding-right: 15px" v-if="items.length !== 0">
      <b-col>
        <md-card>
          <md-card-content style="margin-top: 16px">
            <b-row>
              <b-col>
                <b-table striped :items="items"
                         :fields="fields_table"
                         thead-tr-class="no-border"
                >
                  <template v-slot:cell(controls)="data">
                    <check-icon v-if="data.item.finish_date === null"
                                title="Fertigstellen"
                                class="icon-1_5x ml-2 hoverable-icon" fillColor="#16aa13" :size="72"
                                style="color: green"  v-on:click="finishTask(data.item.id)"

                    >
                    </check-icon>
                    <delete-icon
                        title="Löschen"
                        class="icon-1_5x ml-2 hoverable-icon" fillColor="#f44336" :size="72"
                        style="color: #f44336" v-on:click="deleteTask(data.item.id)"
                    ></delete-icon>
                  </template>
                </b-table>
              </b-col>
            </b-row>
          </md-card-content>
        </md-card>
      </b-col>
    </b-row>
    <b-row v-else>
      <b-col></b-col>
      <b-col>
        <md-card class="mt-5">
          <md-card-header style="border-bottom: 1px solid lightgray;">
            <span style="color: darkslategrey"><b>Keine Termine gefunden</b></span>
          </md-card-header>
          <md-card-content style="margin-top: 16px">
            Zu diesem Baum liegen noch keine Termine vor.
          </md-card-content>
        </md-card>
      </b-col>
      <b-col></b-col>
    </b-row>

    <b-modal
        centered
        v-model="show_delete"
        title="Termin löschen"
        cancel-title="Abbrechen"
        ok-title="Löschen"
        @ok="onDelete"
        ok-variant="danger"
    >Möchten Sie diesen Termin wirklich löschen ?<br>Dies kann nicht rückgängig gemacht werden.</b-modal>
    <b-modal
        centered
        v-model="show_finish"
        title="Termin fertigstellen"
        cancel-title="Abbrechen"
        ok-title="Fertigstellen"
        @ok="onFinish"

        ok-variant="success"
    >Möchten Sie diesen Termin fertigstellen ?<br>Dies kann nicht rückgängig gemacht werden.</b-modal>

    <b-modal
        centered
        v-model="showCreateAppointment"
        title="Termin anlegen"
        cancel-title="Abbrechen"
        ok-title="Anlegen"
        @ok="onCreateAppointment"
        ok-variant="info"
    >
      <b-row>
        <b-col>
          <p style="margin-bottom: 0.5rem">Terminname:</p>
          <b-form-input class="form-control"
                        v-model="createAppointment.name">

          </b-form-input>
          <p style="margin-bottom: 0.5rem; margin-top: 1rem">Beschreibung:</p>
          <b-form-textarea style="margin-top: 8px"
                           placeholder="Beschreibung des Termins"
                           rows="10"
                           no-resize
                           v-model="createAppointment.description"
                           class="black"

          ></b-form-textarea>
          <p style="margin-bottom: 0.5rem; margin-top: 1rem">Zieldatum:</p>
          <datetime
              v-model="createAppointment.due_date"
              input-class="form-control"
              input-style="color: black;"
              :phrases="datetimeConfig.phrases"
              :format="{ day: '2-digit', month: '2-digit', year: 'numeric'}"
              :min-datetime="datetimeConfig.minTime"
              placeholder="Zieldatum"
              style="margin-bottom: 1rem"
          ></datetime>
        </b-col>
      </b-row>
    </b-modal>

  </div>

</template>

<script>
import {Server_URL} from "../../shared/utils";
import ImageIcon from 'vue-material-design-icons/Image.vue';
import TextIcon from 'vue-material-design-icons/CommentText.vue';
import CoolLightBox from 'vue-cool-lightbox'
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'


import DeleteIcon from 'vue-material-design-icons/Delete.vue';
import CheckIcon from 'vue-material-design-icons/CheckCircle';
import PlanIcon from 'vue-material-design-icons/AccountMultipleCheck';
import OpenIcon from 'vue-material-design-icons/OpenInNew.vue';


import {DateTime as LuxonDateTime} from 'luxon'

export default {
  name: "controls",
  components: {
    ImageIcon,
    TextIcon,
    CoolLightBox,
    DeleteIcon,
    CheckIcon,
    PlanIcon,
    OpenIcon
  },
  mounted() {
    this.canGoBack = window.history.length > 1;
    this.tree_number = this.$route.params.id;
    this.showLoader();
    this.$http.get(
        Server_URL + '/baumkontrolle/tree_appintments/'+this.$route.params.id
    ).then(this.responseOkGet, this.responseError)
  },
  data() {
    return {
      canGoBack: false,
      no_tasks: false,
      images: [
        '',
      ],
      index: null,
      text: "",
      loader: undefined,
      fields_table: [
        {key: "name", label: "Terminname"},
        {key: "description", label: "Beschreibung"},
        {key: "due_date", label: "Zieldatum", formatter: this.dateFormater},
        {key: "finish_date", label: "Erledigt", formatter: this.dateFormater},
        {key: "controls", label: ""},
      ],
      items: [],
      tree_number: "",
      currentTask: null,
      show_delete: false,
      show_finish: false,
      show_plan: false,
      datetimeConfig: {phrases: {ok: 'Ok', cancel: 'Abbruch'}, minTime: LuxonDateTime.local().toISO()},
      taskDate: null,
      taskGroup: null,
      taskGroups: [
        {text: "Bauhof allgemein", value: "Bauhof allgemein"},
      ],
      planable: true,
      sendable: false,
      show_send: false,
      showCreateAppointment: false,
      createAppointment: {
        name: "",
        description: "",
        due_date: null,
      }
    }
  },
  methods: {
    showAppointmentModal() {
      this.createAppointment = {
        name: "",
        description: "",
        due_date: null,
      };
      this.showCreateAppointment = true;
    },
    onCreateAppointment(event) {
      if (this.createAppointment.due_date === null || this.createAppointment.due_date === "" || this.createAppointment.name === "") {
        event.preventDefault();
        this.$bvToast.toast(`Bitte wählen Sie ein Datum UND einen Terminnamen.`, {
          title: 'Speichern nicht möglich',
          autoHideDelay: 3000,
          appendToast: false,
          toaster: 'b-toaster-top-center',
        });
        return;
      }
      this.showLoader();
      this.$http.post(
          Server_URL + '/baumkontrolle/appintment/'+this.$route.params.id, {
            name: this.createAppointment.name,
            description: this.createAppointment.description,
            due_date: this.createAppointment.due_date,
          }
      ).then(this.responseOkGet, this.responseError)
      this.showCreateAppointment = false;
    },
    goBack(){
      this.$router.go(-1);
    },
    gotoTree() {
      this.$router.push({ path: `/tree/show/${this.$route.params.id}` })
    },
    gotoControls() {
      this.$router.push({ path: `/tree/controls/${this.$route.params.id}` })
    },
    gotoTasks() {
      this.$router.push({ path: `/tree/tasks/${this.$route.params.id}` })
    },

    showLoader() {
      if (this.loader === undefined) {
        this.loader = this.$loading.show();
      }
    },
    hideLoader() {
      if (this.loader !== undefined) {
        this.loader.hide();
        this.loader = undefined;
      }
    },
    responseError(response) {
      this.hideLoader();
      if (response.status === 401) {
        console.log(response);
      } else {
        console.log(response);
      }
    },
    responseOkGet(response) {
      this.hideLoader();
      if (response.status === 200) {
        this.tree_number = response.data.tree_number;
        this.items = response.data.appointments;
        if (this.items.length === 0) {
          this.no_tasks = true;
        } else {
          this.tree_number = this.items[0].tree_number;
        }
      } else {
        console.log(response);
      }
    },
    responseOkReload(response) {
      if (response.status === 200) {
        this.$http.get(
            Server_URL + '/baumkontrolle/tree_appintments/'+this.$route.params.id
        ).then(this.responseOkGet, this.responseError)
      } else {
        console.log(response);
      }
    },
    dateFormater(value) {
      if (value === null) {
        return ""
      }
      let event = new Date(value.replace('Z',''));
      let options = { year: 'numeric', month: '2-digit', day: '2-digit' };
      return event.toLocaleDateString('de-DE', options);
    },

    deleteTask(id) {
      this.currentTask = id;
      this.show_delete = true;
    },
    onDelete() {
      if (this.currentTask !== null) {
        this.showLoader();
        this.$http.delete(
            Server_URL + '/baumkontrolle/appintment/' + this.currentTask
        ).then(this.responseOkReload, this.responseError);
        this.currentTask = null;
      }
    },

    finishTask(id) {
      this.currentTask = id;
      this.show_finish = true;
    },
    onFinish() {
      if (this.currentTask !== null) {
        this.showLoader();
        this.$http.patch(
            Server_URL + '/baumkontrolle/appintment/' + this.currentTask
        ).then(this.responseOkReload, this.responseError);
        this.currentTask = null;
      }
    },
  }
}
</script>
<style>
.custom-checkbox .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgb(66, 139, 202);
}

.black {
  color: #000;
}

.modal-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.modal-container {
  display: inline-block;
  width: auto;
}
.no-border th {
  border-top: none;
}
</style>
<style scoped>

.hoverable:hover {
  color: #23282c;
  background-color: rgba(0, 0, 0, 0.075);
  cursor: pointer;
}

.hoverable-icon:hover {
  cursor: pointer;
}
</style>
